import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../_common/button';
import pluralize from '../../../_utils/tools/pluralize';

export default function MultiSelectModal({
  handleShowMultiSelectModal,
  multiSelectItemsCount,
  maximumSelected,
  showMultiSelectModal,
  handleMultiSelectAll,
  handleMultiUnSelectAll,
  handleMultiDelete,
  handleMultiResize,
}) {
  const bulkSelectText = (maximumSelected && 'Unselect All') || 'Select All';

  function handleBulkSelect() {
    if (maximumSelected) {
      handleMultiUnSelectAll();
    } else {
      handleMultiSelectAll();
    }
  }

  return (
    <div
      role="dialog"
      className={`multi-select-modal w-100 ${
        showMultiSelectModal ? 'd-block' : 'd-none'
      }`}>
      <div className="multi-select-modal__button-wrapper row">
        <div className="col-12 mb-2 text-center position-relative">
          <p
            aria-label={`${multiSelectItemsCount} ${pluralize(
              'photo',
              multiSelectItemsCount
            )} selected`}
            className="multi-select-modal__selected-text m-0">
            {multiSelectItemsCount}{' '}
            <small className="muted">
              {pluralize('photo', multiSelectItemsCount)} selected
            </small>
          </p>
          <Button
            onClick={handleShowMultiSelectModal}
            type="button"
            className="multi-select-modal__close-btn position-absolute"
            aria-label="Close Multi Select"
          />
        </div>
        <div role="toolbar" className="col-12 d-flex justify-content-between">
          <Button
            type="button"
            disabled={multiSelectItemsCount === 0}
            onClick={handleMultiDelete}
            className="w-100 multi-select-modal__remove"
            aria-label="Remove Selected">
            <span className="multi-select-modal__remove-icon"></span>
            <span>Remove</span>
          </Button>
          <Button
            text={bulkSelectText}
            type="button"
            className="w-100 multi-select-modal__bulk-select border border-dark"
            aria-label={bulkSelectText}
            onClick={handleBulkSelect}
          />
          <Button
            type="button"
            disabled={multiSelectItemsCount === 0}
            onClick={handleMultiResize}
            className="w-100 multi-select-modal__resize"
            aria-label="Resize Selected">
            <span className="multi-select-modal__resize-icon"></span>
            <span>Resize</span>
          </Button>
        </div>
      </div>
    </div>
  );
}

MultiSelectModal.propTypes = {
  showMultiSelectModal: PropTypes.bool.isRequired,
  maximumSelected: PropTypes.bool.isRequired,
  multiSelectItemsCount: PropTypes.number.isRequired,
  handleShowMultiSelectModal: PropTypes.func.isRequired,
  handleMultiSelectAll: PropTypes.func.isRequired,
  handleMultiUnSelectAll: PropTypes.func.isRequired,
  handleMultiDelete: PropTypes.func.isRequired,
  handleMultiResize: PropTypes.func.isRequired,
};
